import { Link } from "react-router-dom";
import { ChevronRight, Crown } from "lucide-react";
import VipMedallion from "./VipMedallion";
import { VIP_TIERS } from "@/lib/vipTiers";

// Compact "How badges work" strip reused by Coin Store, Creator dashboard, gift sheet and live supporter views.
export default function VipTiersStrip({ context, title = "Monthly VIP badges", subtitle = "Verified coin purchases this month unlock Green → Panda Boss. Resets on the 1st.", className = "", onNavigate }) {
  return (
    <Link
      to="/vip"
      onClick={onNavigate}
      data-testid={`vip-strip-${context}`}
      className={`group flex flex-wrap items-center gap-3 p-4 border border-white/10 bg-black/40 hover:bg-white/[0.04] hover:border-rose-500/50 transition-colors ${className}`}
    >
      <div className="flex items-center -space-x-2 shrink-0">
        {VIP_TIERS.map((t) => <VipMedallion key={t.tier} tier={t.tier} size="xs" className="ring-2 ring-zinc-950" />)}
      </div>
      <div className="flex-1 min-w-[150px]">
        <div className="flex items-center gap-1.5 text-white text-sm font-medium leading-tight"><Crown size={13} className="text-amber-300" /> {title}</div>
        <div className="text-[11px] text-zinc-500 leading-snug mt-0.5">{subtitle}</div>
      </div>
      <span className="text-[10px] uppercase tracking-widest text-rose-400 group-hover:text-rose-300 flex items-center gap-0.5 shrink-0 whitespace-nowrap ml-auto">How it works <ChevronRight size={12} /></span>
    </Link>
  );
}
